import { useLocation } from 'react-router-dom';

export const useUrlParameterCheck = (paramName: string) => {
  const location = useLocation();
  const segment = paramName.replace('/', '');
  return location.pathname.split('/').includes(segment);
};
